$bog_ui_app_tooltip $mol_page
	title \Tooltip
	body /
		<= Description $mol_view
			sub /
				<= description \Instant CSS-tooltip plugin. Plug it once into the root view's `plugins /`, then any element with `title=` or any $mol component with `hint` shows a custom bubble without the native ~700ms browser delay.
		<= Usage_title $mol_view
			sub /
				<= usage_title \Usage
		<= Usage_code $mol_view
			sub /
				<= usage_code \plugins /\n    <= Tip $bog_ui_tooltip
		<= Demo_title $mol_view
			sub /
				<= demo_title \Demo
		<= Demo_hint $mol_view
			sub /
				<= demo_hint \Hover any of the elements below — the bubble appears immediately.
		<= Demo $mol_view
			sub /
				<= Btn_simple $mol_button_minor
					hint \Hello, I am a tooltip
					sub / \Simple
				<= Btn_long $mol_button_minor
					hint \A longer hint that explains in detail what this control will do when activated.
					sub / \Long text
				<= Btn_icon $mol_button_minor
					hint \Settings
					sub /
						<= Btn_icon_glyph $mol_icon_cog
				<= Btn_input $mol_button_open
					hint \Pick a file from disk
					accept \image/*
					files? <=> demo_files? /File
				<= Inline_text $mol_view
					attr *
						title \Plain HTML title attribute on a span
					sub / \Hover this text
